export default __webpack_public_path__ + "media/images/theme/bg_light-91cff1eb2fdbbc2b0803c6d4a12547b3.png";